import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

const pca = new PublicClientApplication(msalConfig);
window.msalInstance = pca;

// Initialize MSAL and handle redirect results properly
const initializeMsal = async () => {
  try {
    // ⭐ REQUIRED: Initialize MSAL first before calling any other APIs
    await pca.initialize();

    // ⭐ REQUIRED: Handle redirect results after initialization
    const response = await pca.handleRedirectPromise();
    if (response) {
      pca.setActiveAccount(response.account);
    } else {
      // Set active account if user is already logged in
      const accounts = pca.getAllAccounts();
      if (accounts.length > 0) {
        pca.setActiveAccount(accounts[0]);
      }
    }

    // ⭐ REQUIRED: Ensure login success is stored
    pca.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        pca.setActiveAccount(event.payload.account);
      }
    });

    // Render the React app only after MSAL is fully initialized
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <MsalProvider instance={pca}>
        <App />
      </MsalProvider>
    );
  } catch (error) {
    console.error("Failed to initialize MSAL:", error);
    // Show error message to user
    document.getElementById("root").innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: Arial, sans-serif;">
        <div style="text-align: center; color: #d32f2f;">
          <h2>Authentication Error</h2>
          <p>Failed to initialize authentication. Please refresh the page or contact support.</p>
          <button onclick="window.location.reload()" style="margin-top: 10px; padding: 10px 20px; background: #1976d2; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Retry
          </button>
        </div>
      </div>
    `;
  }
};

// Initialize MSAL when the page loads
initializeMsal();
